export const SIDEBAR_CONTENT_OFFSET_CSS_VAR = '--sidebar-content-offset';
export const SIDEBAR_CONTENT_TOP_CSS_VAR = '--sidebar-content-top';
export const SIDEBAR_MOBILE_TOP_OFFSET = 65;

export type SidebarLayoutMetrics = {
  asideWidth: number;
  isMobile: boolean;
  contentOffset: number;
  contentTop: number;
};

export function getSidebarLayoutMetrics(
  asideWidth: number,
  isMobile: boolean,
): SidebarLayoutMetrics {
  const contentOffset = isMobile ? 0 : asideWidth;
  const contentTop = contentOffset > 0 ? 0 : SIDEBAR_MOBILE_TOP_OFFSET;

  return {
    asideWidth,
    isMobile,
    contentOffset,
    contentTop,
  };
}

export function applySidebarLayoutCssVars(metrics: SidebarLayoutMetrics): void {
  document.documentElement.style.setProperty(
    SIDEBAR_CONTENT_OFFSET_CSS_VAR,
    `${metrics.contentOffset}px`,
  );
  document.documentElement.style.setProperty(
    SIDEBAR_CONTENT_TOP_CSS_VAR,
    `${metrics.contentTop}px`,
  );
}

export function clearSidebarLayoutCssVars(): void {
  document.documentElement.style.removeProperty(SIDEBAR_CONTENT_OFFSET_CSS_VAR);
  document.documentElement.style.removeProperty(SIDEBAR_CONTENT_TOP_CSS_VAR);
}
